import { HistoryDelegationUser } from '../../Entities/History.Delegation.User.Entity';
import { BaseApi } from '../index.exports';

export class HistoryDelegationUserFrontEndApiCalls extends BaseApi {
    protected static _Entity = HistoryDelegationUser;

    // #region api

    // #endregion api
}
